// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"9ae91f2e","130":"08091a9c","276":"776e2407","344":"4f5bc160","355":"3498371f","501":"f3c6fede","509":"024b2fce","621":"d412ecbf","806":"db5a904c","820":"29d8e25f","870":"3a08f9ae"}[chunkId] + ".chunk.js";
};